import * as core from "../redux/modules/core";
import * as home from "../redux/modules/home";

// It's a timer object
let timer = null;

export const homeController = {
  /**
   * ログインユーザーの情報を取得
   */
  fetchMyInformation: () => (dispatch, getState, { request, storage }) => {
    dispatch(home.actions.setLoading(true));

    request({
      url: "/api/v1/action_point/me/",
      headers: {
        Authorization: storage.get("reward-app-token"),
      },
    })
      .then((result) => {
        if (result.data) {
          dispatch(home.actions.succeededFetchMyInformationApi(result.data));

          // パスワード変更要求がある場合は、強制的にパスワード変更画面へ
          if (result.data.changePasswordRequired) {
            dispatch(home.actions.changePasswordRequired());
          }
        }
      })
      .catch((error) => {
        if (error.code === "401") {
          dispatch(core.actions.happenedApiUnauthorized());
        }
      })
      .finally(() => {
        dispatch(home.actions.setLoading(false));
      });
  },
  /**
   * transient_reward_number を取得
   */
  fetchTransientRewardToken: () => (
    dispatch,
    getState,
    { request, storage }
  ) => {
    if (getState().home.loading) {
      return;
    }
    dispatch(home.actions.setLoading(true));
    request({
      method: "POST",
      url: "/api/v1/action_point/transient_reward_token/",
      headers: {
        Authorization: storage.get("reward-app-token"),
      },
    })
      .then((result) => {
        if (result.data.data) {
          dispatch(
            home.actions.succeededFetchTransientRewardTokenApi(result.data.data)
          );

          const QRCode = require("qrcode");
          const options = {
            errorCorrectionLevel: "L",
            type: "image/jpeg",
            margin: 1,
            width: 240,
            rendererOpts: {
              quality: 0.3,
            },
          };

          // QR コード生成
          const embbededData = {
            transient_reward_token: result.data.data.transient_reward_token,
          };
          QRCode.toCanvas(
            JSON.stringify(embbededData),
            options,
            (error, canvas) => {
              if (error) throw error;

              dispatch(home.actions.builtQrCode(canvas.toDataURL()));
            }
          );
        }
      })
      .catch((error) => {
        if (error.code === "401") {
          dispatch(core.actions.happenedApiUnauthorized());
        }
      })
      .finally(() => {
        dispatch(home.actions.setLoading(false));
      });
  },
  startTimer: () => (dispatch, getState, { request }) => {
    clearInterval(timer);
    timer = setInterval(() => {
      let homeState = getState().home || {};

      if (homeState.forceReloadingAt < new Date()) {
        // transient reward number を再取得
        dispatch(homeController.fetchTransientRewardToken());
      } else if (homeState.timer > 0) {
        dispatch(home.actions.tickTimer());
      } else {
        // transient reward number を再取得
        dispatch(homeController.fetchTransientRewardToken());
      }
    }, 1000);
  },
  stopTimer: () => (dispatch, getState, { request }) => {
    clearInterval(timer);
  },

  /**
   * サインアウトを実行
   */
  signOut: () => (dispatch, getState, { request, storage }) => {
    storage.remove("reward-app-token");
    dispatch(home.actions.signedOut());
  },
};
